module.exports = __webpack_public_path__ + "static/media/Palm_Springs_California.1c24ec8f.png";